import React, { useState } from 'react';
import { Logo, EntityLink } from './ui';

function dv(row, code) {
  if (!row) return null;
  const d = Array.isArray(row.details) ? row.details.find((x) => x?.type?.code === code) : null;
  return d?.value ?? null;
}

const COLS = {
  overall: { p: 'overall-matches-played', w: 'overall-won', d: 'overall-draw', l: 'overall-lost', gf: 'overall-goals-for', ga: 'overall-goals-against', pts: 'overall-points' },
  home: { p: 'home-matches-played', w: 'home-won', d: 'home-draw', l: 'home-lost', gf: 'home-scored', ga: 'home-conceded', pts: 'home-points' },
  away: { p: 'away-matches-played', w: 'away-won', d: 'away-draw', l: 'away-lost', gf: 'away-scored', ga: 'away-conceded', pts: 'away-points' },
};

export default function StandingsTable({ rows, highlightParticipantId }) {
  const [mode, setMode] = useState('overall');
  if (!Array.isArray(rows) || !rows.length) {
    return <p className="i-dim text-sm">No standings available.</p>;
  }
  const c = COLS[mode] || COLS.overall;
  return (
    <div>
      <div className="flex gap-2 mb-3">
        {['overall', 'home', 'away'].map((m) => (
          <button key={m} className={'i-btn ' + (m === mode ? '' : 'i-ghost-btn')} onClick={() => setMode(m)} style={{ padding: '6px 12px' }}>{m}</button>
        ))}
      </div>
      <div className="overflow-x-auto">
        <table className="i-table min-w-[640px]">
          <thead>
            <tr><th>#</th><th>Club</th><th>P</th><th>W</th><th>D</th><th>L</th><th>GF</th><th>GA</th><th>Pts</th></tr>
          </thead>
          <tbody>
            {rows.map((r, i) => {
              const pid = r?.participant?.id || r?.participant_id || r?.team?.id || r?.id;
              const name = r?.participant?.name || r?.team?.name || r?.name || '—';
              const logo = r?.participant?.image_path || r?.team?.image_path || r?.image_path;
              const pts = dv(r, c.pts) ?? r?.points;
              return (
                <tr key={i} style={pid === highlightParticipantId ? { background: 'rgba(255,255,255,.04)' } : undefined}>
                  <td>{r?.position ?? i + 1}</td>
                  <td>
                    <div className="flex items-center gap-2">
                      <Logo src={logo} alt={name} size={20} fallback={name} />
                      <EntityLink to={pid ? `/club/${pid}` : null} className="i-fg">{name}</EntityLink>
                    </div>
                  </td>
                  <td>{dv(r, c.p) ?? '—'}</td>
                  <td>{dv(r, c.w) ?? '—'}</td>
                  <td>{dv(r, c.d) ?? '—'}</td>
                  <td>{dv(r, c.l) ?? '—'}</td>
                  <td>{dv(r, c.gf) ?? '—'}</td>
                  <td>{dv(r, c.ga) ?? '—'}</td>
                  <td className="i-fg font-bold">{pts ?? '—'}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
